module.exports = __webpack_public_path__ + "static/media/5@1024w.d3337e07.jpg";